import { render } from "./ResendCodeBtn.vue?vue&type=template&id=f9cb93bc&ts=true"
import script from "./ResendCodeBtn.vue?vue&type=script&lang=ts"
export * from "./ResendCodeBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__